module.exports = __webpack_public_path__ + "static/latisse.253a98bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/partners/latisse.png
// module id = 615
// module chunks = 114276838955818